const items = [
  "Fitur Pro Terbuka",
  "Tanpa Watermark",
  "Ekspor Hingga 4K",
  "Template Premium",
  "Auto Captions",
  "AI Tools",
  "Efek & Filter Pro",
  "Proses Instan",
];

const Row = () => (
  <div className="flex items-center gap-8 shrink-0 pr-8">
    {items.map((item) => (
      <span key={item} className="flex items-center gap-8">
        <span className="font-capcut-heading font-bold text-slate-800 text-base md:text-lg whitespace-nowrap">{item}</span>
        <span className="w-1.5 h-1.5 rounded-full bg-blue-500 shrink-0" />
      </span>
    ))}
  </div>
);

export const CapCutMarquee = () => (
  <div className="bg-white border-y border-slate-200 py-4 overflow-hidden" data-testid="capcut-marquee">
    <div className="flex marquee-track w-max">
      <Row />
      <Row />
    </div>
  </div>
);
